var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2966 9.89986L15.8156 4.37263L19.7029 3.05079C20.2429 2.86719 20.8185 3.19791 20.9653 3.77607L21.9659 7.71626C22.1127 8.29442 21.7709 8.88451 21.2164 9.01036L17.2966 9.89986Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 10.2321L12.747 10.9323C12.749 10.9546 12.75 10.9772 12.75 11V14.75H15C15.4142 14.75 15.75 15.0858 15.75 15.5C15.75 15.9142 15.4142 16.25 15 16.25H13.4728L16.6066 20.5589C16.8502 20.8939 16.7761 21.3629 16.4411 21.6066C16.1061 21.8502 15.6371 21.7761 15.3934 21.4411L12.75 17.8064V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V17.8064L8.60654 21.4411C8.36291 21.7761 7.89385 21.8502 7.55886 21.6066C7.22387 21.3629 7.14981 20.8939 7.39344 20.5589L10.5272 16.25H8.99999C8.58578 16.25 8.24999 15.9142 8.24999 15.5C8.24999 15.0858 8.58578 14.75 8.99999 14.75H11.25V11.272L9.48907 11.6716L8.22492 6.95373L14.3924 4.85657L15.8327 10.2321Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68787 8.83654C2.18478 9.00761 1.8972 9.56488 2.03401 10.1036L2.57249 12.2241C2.70929 12.7628 3.22242 13.0937 3.73917 12.9764L8.02518 12.0038L6.80169 7.43768L2.68787 8.83654Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.e8ac99c93dbf83e256e8dbb82dd81d57.svg";
export { ForwardRef as ReactComponent };